/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import Colors from "constants/Colors";
import { FontWeight, Text } from "components/Text";
import { Breakpoints } from "../../constants/Breakpoints";

const Container = styled.div`
  .profile-open {
    right: 0px;
  }

  .icon-menu {
    display: inline-block;
    padding: 3px 0;
    float: left;
  }

  .menu-open {
    left: 0px;
    box-shadow: 5px 0px 6px 1px rgba(179, 174, 174, 0.17);
    top: 0;
  }

  .menu-close {
    left: -340px;
    top: 0;
  }

  @media (min-width: ${Breakpoints.xl}) {
    .icon-menu {
      display: none;
    }
  }
`;

export const Scrollbox = styled.div`
  height: auto;
  padding: 10px 0 0;

  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }

  @media screen and (min-width: ${Breakpoints.sm}) {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px 10px;
  }
`;

const Main = styled.div`
  width: 100%;
  background: ${Colors.WHITE};
  // box-shadow: -3px 7px 6px 1px rgba(179, 174, 174, 0.17);
  border-radius: 0px 0px 0px 40px;
  padding: 10px 0.5rem 30px;
  height: 100%;

  @media (min-width: ${Breakpoints.sm}) {
    height: 80vh;
    margin-left: 0px;
  }

  @media (min-width: ${Breakpoints.xl}) {
    /* width: calc(100% - 350px); */
    height: 65vh;
    padding: 30px;
    /* margin-left: 350px; */
  }
`;

const Title = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 15px;
  font-weight: ${FontWeight.Bold};
  color: ${Colors.GRAY[6]};

  @media (min-width: ${Breakpoints.sm}) {
    font-size: 22px;
    margin-top: 0px;
    display: unset;
  }

  @media (min-width: ${Breakpoints.md}) {
    font-size: 28px;
  }
`;

const Subtitle = styled(Text)`
  font-size: 12px;
  margin-top: 0;

  font-weight: ${FontWeight.Medium};
  color: ${Colors.GRAY[6]};
  display: block;

  @media (min-width: ${Breakpoints.sm}) {
    font-size: 14px;
    margin-top: 15px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    font-size: 16px;
  }
`;

const Logo = styled.img`
  max-width: 30px;
  max-height: 30px;
  margin: 0 auto;
  display: block;
`;

const User = styled.div`
  width: 30px;
  float: right;
  cursor: pointer;

  @media (min-width: ${Breakpoints.sm}) {
    width: 70px;
  }

  @media (min-width: ${Breakpoints.xl}) {
    width: 250px;
  }
`;

const Photo = styled.div`
  width: 30px;
  height: 30px;
  margin: 0;
  padding: 0;

  background: ${Colors.WHITE};
  box-shadow: 0px 8px 20px 3px rgba(171, 171, 171, 0.22);
  border-radius: 50px;
  float: left;

  .icon-user-gray:before {
    background-size: 25px 20px;
    background-repeat: no-repeat;
    background-position: center;
    width: 30px;
    height: 24px;

    border-radius: 8px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: -15px;
  }

  .icon-check-ok {
    margin-left: 40px;
    margin-top: -5px;
    float: right;
  }

  .icon-check-ok:before {
    width: 20px;
    height: 20px;

    background-size: contain;
    display: inline-block;
    content: "";
    border-radius: 20px;
  }

  @media (min-width: ${Breakpoints.sm}) {
    width: 60px;
    height: 60px;
    margin-top: -10px;
    margin-right: 20px;
    margin-bottom: 30px;
    padding-top: 10px;

    .icon-user-gray:before {
      background-size: contain;
      width: 38px;
      height: 32px;
    }

    .icon-check-ok:before {
      width: 24px;
      height: 24px;
    }
  }
`;

const Name = styled(Text)`
  font-size: 16px;
  display: none;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};

  @media (min-width: ${Breakpoints.xl}) {
    display: block;
  }
`;

const Country = styled(Text)`
  font-size: 15px;
  display: none;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};

  @media (min-width: ${Breakpoints.xl}) {
    display: unset;
  }
`;

const ContentProfile = styled.div`
  transition: all 0.5s ease;
  background: ${Colors.WHITE};
  z-index: 1000;
  right: -340px;
  width: 100%;
  position: fixed;
  top: 0px;
  bottom: 0px;
  box-shadow: -5px 0px 6px 1px rgba(179, 174, 174, 0.17);
  overflow-y: auto;
  overflow-x: hidden;
  .icon-close {
    z-index: 100;
    position: relative;
    margin: 10px;
    font-size: 30px;
    cursor: pointer;
    float: right;
  }

  @media screen and (min-width: ${Breakpoints.xs}) {
    width: 340px;
  }
`;

const ContentMenu = styled.div`
  transition: all 0.5s ease;
  background: ${Colors.WHITE};
  z-index: 101;
  position: fixed;
  min-height: calc(100vh - 70px);
  height: 100%;
  width: 100%;

  .icon-close {
    z-index: 100;
    margin: 10px;
    font-size: 30px;
    cursor: pointer;
    left: 0px;
    position: absolute;
  }

  @media screen and (min-width: ${Breakpoints.xxs}) {
    width: unset;
  }
`;

const IconNotification = styled.div`
  background: red;
  color: ${Colors.WHITE};
  border-radius: 11px;
  text-align: center;
  font-size: 9px;
  font-weight: normal;
  line-height: 14px;
  margin-left: 20px;
  margin-top: -5px;
  height: 14px;
  width: 14px;
  cursor: pointer;

  @media (min-width: ${Breakpoints.sm}) {
    font-size: 13px;
    font-weight: 800;
    line-height: unset;
    margin-left: 35px;
    margin-top: unset;
    height: 22px;
    width: 22px;
  }
`;

export {
  Container,
  Main,
  Title,
  Subtitle,
  Logo,
  User,
  Photo,
  Name,
  Country,
  ContentProfile,
  ContentMenu,
  IconNotification,
};
